<template>
  <div class="modal-background">
    <div class="modal-content">
      <div class="modal-title">{{ title }}</div>

      <slot>

      </slot>
      <div>
        <v-btn class="mr-4" color="grey" dark @click="$emit('cancel')">{{ $t('Cancel') }}</v-btn>
        <v-btn
          :color="isNegative ? 'red' : 'primary'"
          dark
          @click="$emit('confirm')"
        >{{ confirmText }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ConfirmationModal',
  props: {
    title: {
      default: 'Give me a title',
      type: String,
    },
    confirmText: {
      default() {
        return this.$t('Confirm');
      },
      type: String,
      required: false,
    },
    cancelText: {
      default() {
        return this.$t('Cancel');
      },
      type: String,
      required: false,
    },
    isNegative: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped>
  .modal-background {
    background-color: rgba(0, 0, 0, 0.2);
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    animation: fadeIn 0.2s forwards linear;
  }

  .modal-content {
    background-color: #fff;
    padding: 32px 128px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .modal-title {
    font-size: 30px;
    color: #707070;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
</style>
